import { IconProps } from './types';

export function Books({ size, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.5 5.5C1.96957 5.5 1.46086 5.71071 1.08579 6.08579C0.710714 6.46086 0.5 6.96957 0.5 7.5V18.5M0.5 18.5C0.5 17.9696 0.710714 17.4609 1.08579 17.0858C1.46086 16.7107 1.96957 16.5 2.5 16.5H3.303M0.5 18.5C0.5 19.0304 0.710714 19.5391 1.08579 19.9142C1.46086 20.2893 1.96957 20.5 2.5 20.5H12C12.1326 20.5 12.2598 20.4473 12.3536 20.3536C12.4473 20.2598 12.5 20.1326 12.5 20V19.5M6.5 13.5V2.5C6.5 1.96957 6.71071 1.46086 7.08579 1.08579C7.46086 0.710714 7.96957 0.5 8.5 0.5H18C18.1326 0.5 18.2598 0.552679 18.3536 0.646447C18.4473 0.740215 18.5 0.867392 18.5 1V15C18.5 15.1326 18.4473 15.2598 18.3536 15.3536C18.2598 15.4473 18.1326 15.5 18 15.5H8.5C7.96957 15.5 7.46086 15.2893 7.08579 14.9142C6.71071 14.5391 6.5 14.0304 6.5 13.5ZM6.5 13.5C6.5 12.9696 6.71071 12.4609 7.08579 12.0858C7.46086 11.7107 7.96957 11.5 8.5 11.5H18.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
